var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "title-bar-content-container" },
    [
      _vm.showAppBar
        ? _c(
            "v-toolbar",
            { attrs: { color: "primary", flat: "" } },
            [
              _c("v-avatar", { staticClass: "mr-4", attrs: { size: "36" } }, [
                _vm.avatarUrl
                  ? _c("img", { attrs: { src: _vm.avatarUrl } })
                  : _c("img", { attrs: { src: "/quickytools.svg" } }),
              ]),
              _c(
                "v-toolbar-title",
                { staticClass: "h6-material quickytools-font" },
                [_vm._v(_vm._s(_vm.day6Resource.appTitle))]
              ),
              _c("v-spacer"),
              _c("AccountPaidStatus", {
                on: { "open-account-pay": _vm.openAccountPay },
              }),
              _c("AccountOptionsBar", { staticClass: "ml-4" }),
            ],
            1
          )
        : _vm._e(),
      _c("router-view", { staticClass: "flex-grow-1" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }